// ホテルの空室数。取得元サプライヤーによって意味・表現が異なるため、以下のいずれかで統一する。
// バックエンド側の正規化ルールは app/models/hotel/available_rooms_normalizer.rb を参照。
//
//   number  : 空室数（実数）。「残n室」と表示。Expedia/Agodaが数値を返すケース
//   true    : 正確な数は不明だが在庫ありを示す。「○」＋iアイコンで補足説明を表示。楽天トラベル
//   'many'  : サプライヤーが返す非現実的に大きい値（在庫上限なしのプレースホルダーと推測される値）
//             を丸めたもの。「{閾値}室以上あります」と表示。Expedia/Agoda双方に正規化を適用
//   null    : 値が取得できない場合。何も表示しない
export type AvailableRooms = number | true | 'many' | null;

// バックエンドの Hotel::AvailableRoomsNormalizer::MANY_THRESHOLD と同じ値を保つこと
export const AVAILABLE_ROOMS_MANY_THRESHOLD = 50;
export const AVAILABLE_ROOMS_MANY_TEXT = `${AVAILABLE_ROOMS_MANY_THRESHOLD}室以上あります`;
